import post from '../../../../fns/http/post'
import getHeaders from './headers/index'

const loadPriceTransparency = (data, params, { urls, locale, headers, sessionId, responseProxy }) => {
    return post(`${urls.base.booking}/quote/prices`, data, params, getHeaders({ locale, headers }), { responseProxy })
}
export default loadPriceTransparency
